module.exports = __webpack_public_path__ + "static/media/cikrle5.7b5ebda5.jpg";